import React, { useEffect, useState, useContext } from 'react'

import { StateController } from './../../App'
import Container from '../../layouts/Container/Container'
import PrimaryBanner from '../molecules/PrimaryBanner'
import Preloader from '../atoms/Preloader'

function Terms() {
  const { staticContent } = useContext(StateController)
  const [termsHTML, setTermsHTML] = useState(false)
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY >= 1600) {
        console.log('scrollY', window.scrollY)
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    if (staticContent && staticContent.terms && staticContent.terms[0].content) {
      setTermsHTML(staticContent.terms[0].content)
    }
  }, [staticContent])

  return (
    <>
      {visible &&
        <button className="scroll-top-btn" onClick={scrollToTop}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 19V5M5 12l7-7 7 7"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      }

      <PrimaryBanner
        goBack
        title={<>Términos y condiciones</>}
        description={<>Aclara tus dudas y prepárate para participar.</>}    
      />
      
        
      <div className='mc-page terms slow_ani'>
        <div className='mc-terms-container'>
          <Container>
            {termsHTML
              ? <div className='mc-static-content'>
                <div dangerouslySetInnerHTML={{ __html: termsHTML }} />
              </div>
              : <Preloader
                type="section-red"
                invert
              />
            }
          </Container>
        </div>


      </div>
    </>
  )
}
export default Terms